import axios from '../../axios';

/**
 * 订单统计
 * @param {*} data 
 * schoolName	是	string	驾校名称
payBeginTime	是	string	支付开始时间
payEndTime	是	string	支付结束时间
 * @wiki   http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=17629423  20220805
 */
export const treeOrder = data => {
  return axios({
    url: '/order/totalList',
    method: 'post',
    data,
  })
}
/**
 * 查询订单动态列
 * @param {*} data 
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=17629416  20220805
 */
export const listTableColumn = data => {
  return axios({
    url: '/order/getColumn',
    method: 'post',
    data,
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/statistics/order.js